import PropTypes from "prop-types";
import React from "react";
import styled from "@emotion/styled";

import Button from "~/components/buttons/Button";
import { ArrowIcon } from "~/components/ProductTable";

import { scrollToElement } from "~/utilities/helpers";

const NextSectionButton = styled(Button)`
    align-self: end;
    font-size: 1.6rem;
    margin-bottom: 15px;
    margin-right: ${({ scrollBarHasWidth, theme }) =>
        scrollBarHasWidth ? theme.table.breakContainerOffset : `0`};
    margin-left: auto;
    @-moz-document url-prefix() {
        margin-right: 0;
    }

    @media (max-width: ${({ theme }) =>
            theme.table.breakpoints.filterColumnWrap}) {
        align-self: start;
        margin-right: 0;
        margin-left: 0;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        display: none;
    }
`;

const NextSection = ({ hasFilters, scrollBarHasWidth, targetRef = {} }) => (
    <NextSectionButton
        {...{ hasFilters, scrollBarHasWidth }}
        onClick={() => scrollToElement(targetRef)}
    >
        Next Section
        <ArrowIcon name="chevron-down" />
    </NextSectionButton>
);
NextSection.propTypes = {
    hasFilters: PropTypes.number.isRequired,
    scrollBarHasWidth: PropTypes.bool.isRequired,
    targetRef: PropTypes.shape({}),
};

export default NextSection;
